import { render, staticRenderFns } from "./Home4.vue?vue&type=template&id=2446b5f1&scoped=true&"
import script from "./Home4.vue?vue&type=script&lang=js&"
export * from "./Home4.vue?vue&type=script&lang=js&"
import style0 from "./Home4.vue?vue&type=style&index=0&id=2446b5f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2446b5f1",
  null
  
)

export default component.exports